export default {
	ConnectEsign: {
		Title: 'Set up digital signature',
		ButtonTitle: 'Connect now',
		ConnectedButtonTitle: 'Connected',
		Attention: 'When setting up USB Token digital signature, you should keep in mind as follows:',
		AttentionSecondLine: 'Make sure the USB token is plugged into the computer every time you digitally sign it.'
	},
	ContactAdditionalList: {
		Title: 'Set up digital signature',
		DeleteContactAdditionalConfirmMessage:
			'Deleted email will not be restored. Are you sure you want to delete this email?',
		DeleteSuccessfully: 'Delete email address which receives Tax Authority notification successfully'
	},
	ContactAdditionalDetail: {
		Title: 'Set up digital signature',
		AddSuccessfully: 'Add email address which receives Tax Authority notification successfully',
		UpdateSuccessfully: 'Update email address which receives Tax Authority notification successfully'
	},
	AccessLog: {
		QuickSearchPlaceHolderContent: 'Search action, description, user name, IP address'
	},
	Launcher: {
		PublishInvoice: 'Issue e-invoice',
		Invoice: 'Invoice, warehouse export voucher',
		Receipt: 'Receipt',
		Ticket: 'E-Ticket',
		InvoiveInput: 'Process invoice',
		AutomaticChecker: 'Looking-up, analyzing and checking invoice information automatically.',
		ConnectAccounting:
			'Integrating directly to accounting software, helping accounting staff reduce many operations as well as effort if making these reports and books manually.'
	},
	AgreeBy: 'Gain agreement by',
	PhoneNumber: 'Phone number',
	ViewHistoryConfirm: 'View history',
	AcceptAgreement: "I'm agree with software usage agreement",
	AlertConfirmAgreement: 'Please confirm the agreement to use the software',
	ViewAllAgreement: 'View full usage service agreement',
	AlertUpdateAgreement: 'Notification of update software usage agreement',
	ViewContentChange: 'View change content',
	AcceptAgreementSuccess: 'Accept usage service agreement successfully',
	AcceptAgreementFailed: 'Accept usage service agreement unsuccessfully. Please contact to MISA for support',
	SystemTitle: 'System',
	ManageUser: 'User management',
	ManageRole: 'Roles & permissions',
	ManageResource: 'Resource management',
	DiaryLogs: 'Access log',
	Options: 'Optional',
	UserSettings: 'User settings',
	WarningNoPermission: {
		Title: 'No permission to perform setup',
		Content: role =>
			`You do not have permission to configure <span style='font-weight: 700'>${
				role ? role.toLowerCase() : ''
			}.</span> Please contact a user with Administrator privileges to be granted access.`
	},
	HistoryVatRate: 'History of tax rate acceptance',
	Roles: {
		RoleName: 'Role name',
		NumberUser: 'Number of users',
		CreatedDate: 'Creation date',
		AlertCannotDelete: name => `There are users currently assigned to this role.`,
		CannotDeleteRoleTitle: 'Cannot delete role',
		AlertConfirmDelete: name => `Are you sure you want to delete the role ${name.trim()}?`,
		DeleteSuccess: 'Deleted role successfully',
		DeleteRole: 'Delete role',
		PermissionName: 'Permission name',
		InvoiceInput: 'Input invoice',
		InvoiceOutput: 'Output invoice',
		MailBox: 'Inbox',
		OrgStruct: 'Organization structure',
		InvoiceDetail: 'Invoice details',
		DeleteAndRestore: 'Delete and restore',
		SpamDeleteAndRestore: 'Report Spam, delete and restore',
		NoteAccount: 'Mark as accounted',
		Redirect: 'Transfer',
		NotePaied: 'Mark as paid',
		AcceptSellerBuyer: 'Accept buyer/seller information',
		AcceptSignature: 'Accept digital signature',
		AcceptActiveRisk: "Accept seller's active status and tax risk",
		AlertExistRoles: 'Permission group name has already exists. Please check it again.',
		AutoConnect: 'Auto connect',
		Taxaxion: 'Tax Authority',
		InvoiceSupplier: 'Invoice suppliers',
		IgnoreCheckExistTax: 'Accepted to exist on the Tax Authority',
		HandInput: 'Invoice hand input',
		AcceptVatRate: 'Accept commodity tax rates',
		AcceptOther: 'Other information is accepted',
		AddInvoice: 'Add input invoice',
		SyncInvoice: 'Sync input invoice',
		AddInvoiceOutput: 'Add output invoice',
		SyncInvoiceOutput: 'Sync output invoice',
		SearchPlaceHolder: 'Enter the role name to search.'
	},
	ReportHistoryAutoLoad: 'Report of invoice loading history',
	ReloadData: 'Reload data'
};
